var STEP_TYPE_BUTTON_RESPONSE = 'ButtonResponse';
var STEP_TYPE_INFO = 'Info';
var GTM_EVENT = 'PageView';
var GTM_CATEGORY = 'pure tone hearing test';
var GTM_ACTION = 'step';
var GTM_QUESTION = 'question [count]';
var GTM_RESULT = 'result';
export default {
  STEP_TYPE_BUTTON_RESPONSE: STEP_TYPE_BUTTON_RESPONSE,
  STEP_TYPE_INFO: STEP_TYPE_INFO,
  GTM_EVENT: GTM_EVENT,
  GTM_CATEGORY: GTM_CATEGORY,
  GTM_ACTION: GTM_ACTION,
  GTM_QUESTION: GTM_QUESTION,
  GTM_RESULT: GTM_RESULT
};